import { Layout } from '@eneco/flows/components';
import { createFlowProvider } from '@eneco/flows/utils';

import { routes, actions, initialContext, completionQueryParams } from './ToonCancelationFlow.config';
import { FlowContextToonCancellation } from '../context';

const { Navigation, Provider, Router } = createFlowProvider<FlowContextToonCancellation>({
  routes,
  actions,
  initialContext,
  completionQueryParams,
});

const Flow = () => (
  <Provider>
    <Layout>
      <Layout.Header>
        <Navigation />
      </Layout.Header>
      <Router />
    </Layout>
  </Provider>
);

export default Flow;
